import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import TerminosCondiciones from "../../components/legal/TerminosCondiciones";

function TerminosCondicionesPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            <NavBar />
            <div>
                <TerminosCondiciones />
            </div>
            <Footer />
        </Layout>
    );
}

export default TerminosCondicionesPage;
